
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c5cde2","fill-rule":"evenodd","d":"M13.51 20.427l-2.479 2.604-8.48-8.925-.005.005-2.48-2.604.007-.007-.006-.007L2.546 8.89l.004.004L11.031-.03l2.48 2.604L5.027 11.5l8.482 8.927z"}})])
          )
        }
      }
    